import earnersJson from '../best_credit_earners.json';

export interface Earner {
  originalRank: number;
  tank_name: string;
  avg_credits_earned: number;
  avg_repair: number;
  avg_ammo: number;
  avg_consumables: number;
  avg_clean_credits: number;
  avg_credits_total: number;
  samples: number;
}

export function loadEarners(): Earner[] {
  try {
    console.log('Loading earners.json (raw):', earnersJson);
    if (!Array.isArray(earnersJson)) {
      console.error('earners.json is not an array:', earnersJson);
      throw new Error('earners.json must be an array');
    }
    const earners = earnersJson.map((item: any[]) => {
      if (!Array.isArray(item) || item.length < 9) { // Expecting 9 elements
        console.warn('Invalid Earner array item:', item);
        return null;
      }
      return {
        originalRank: item[0] as number,
        tank_name: item[1] as string,
        avg_credits_earned: item[2] as number,
        avg_repair: item[3] as number,
        avg_ammo: item[4] as number,
        avg_consumables: item[5] as number,
        avg_clean_credits: item[6] as number,
        avg_credits_total: item[7] as number,
        samples: item[8] as number
      } as Earner;
    }).filter((item): item is Earner => item !== null);

    if (earners.length === 0) {
      console.error('No valid earners found in earners.json');
      return [];
    }
    console.log('Parsed earners (array length):', earners.length, 'Sample:', earners.slice(0, 5));
    return earners;
  } catch (error) {
    console.error('Error loading or parsing earners.json:', error);
    return [];
  }
}

export function getBestCreditMakers(): Earner[] {
  const earners = loadEarners();
  console.log('Best earners before sort (array type):', Array.isArray(earners), 'Length:', earners.length);
  const sorted = earners.sort((a, b) => b.avg_clean_credits - a.avg_clean_credits);
  console.log('Best earners (all, sorted):', sorted.length, 'Sample:', sorted.slice(0, 5));
  return sorted; // Return all sorted entries
}
